import { useState, useRef, useCallback } from 'react'
import { TIMEOUT } from './constants'

type UseTimeoutProps = {
  timeout: number
  timeoutFinished: boolean
  timeoutStart: () => void
  timeoutReset: () => void
}

export const useTimeout = (timeoutDuration: number = TIMEOUT): UseTimeoutProps => {
  const [timeoutFinished, timeoutFinishedChange] = useState<boolean>(false)
  const [timeout, timeoutChange] = useState<number>(0)
  const isStopTimeout = useRef<boolean>()

  const timeoutStart = useCallback(() => {
    const start = performance.now()

    isStopTimeout.current = false

    timeoutFinishedChange(false)

    requestAnimationFrame(function animate(time) {
      const timeLeft = Math.round(timeoutDuration - (time - start) / 1000)

      if (timeLeft > 0 && !isStopTimeout.current) {
        timeoutChange(timeLeft)

        if (isStopTimeout) {
          requestAnimationFrame(animate)
        }
      } else {
        timeoutChange(0)
        timeoutFinishedChange(true)
      }
    })
  }, [timeoutDuration])

  const timeoutReset = useCallback(() => {
    isStopTimeout.current = true
  }, [])

  return {
    timeout,
    timeoutFinished,
    timeoutStart,
    timeoutReset,
  }
}
